export default __webpack_public_path__ + "5d4aa42f2b95544017916c0dcca7d2c3.png";